export const goToMainPage = (pageSlug: string): void => {
  window.location.href = `/pages/${pageSlug}`;
};
